/* =======================================================================
      1) BLOQUEO ROBUSTO DE SLIDECART EN FUNNELS (SPA/BFCACHE/REACTIVO)
   ======================================================================= */

(function () {
  const BLOCK_KEYWORDS = [
    '/es/pages/skinny-coffee-en',
    '/es/pages/skinny-coffee',
    '/es/pages/ncb',
    '/pages/ncb',
    '/es/pages/collagen-protein-coffee-en',
    '/es/pages/ncb-vid',
    '/es/pages/skinny-coffee-m',
    '/pages/skinny-coffee-en-video',
    '/es/pages/collagen-protein-coffee',
    '/es/pages/skinny-coffee-s',
    '/pages/night-collagen-burn'
  ];

  function isBlocked() {
    return BLOCK_KEYWORDS.some(k => location.href.includes(k));
  }

  if (!isBlocked()) return;

  window.__SLIDECART_BLOCKED__ = true;

  window.SLIDECART_OPEN = () => {};
  window.SLIDECART_TOGGLE = () => {};
  window.SLIDECART_UPDATE = window.SLIDECART_UPDATE || (() => {});

  const style = document.createElement('style');
  style.textContent = `
    #slidecarthq, .slidecarthq { display:none !important; }
    html.slidecarthq-open, body.slidecarthq-open { overflow:auto !important; }
  `;
  document.head.appendChild(style);
})();

/* =======================================================================
                       2) SLIDECART BUNDLE (RENAME HEADER)
   ======================================================================= */

/*document.addEventListener('DOMContentLoaded', () => {
  typeof disableSlideCart === 'function' && disableSlideCart();

  const NEW_TEXT = 'YOUR SKINNY COFFEE CART';

  function getHeaderEl() {
    // Tu selector original primero
    return (
      document.querySelector('#slidecarthq .header > span') ||
      // fallbacks comunes
      document.querySelector('#slidecarthq .header span') ||
      document.querySelector('#slidecarthq header span') ||
      document.querySelector('#slidecarthq [class*="header"] span') ||
      document.querySelector('.slidecarthq .header > span') ||
      null
    );
  }

  function renameHeader() {
    const el = getHeaderEl();
    if (!el) return false;
    if (el.textContent !== NEW_TEXT) el.textContent = NEW_TEXT;
    return true;
  }

  // Reaplica varias veces (porque el drawer se re-renderiza)
  function kickRename() {
    renameHeader();
    setTimeout(renameHeader, 50);
    setTimeout(renameHeader, 200);
    setTimeout(renameHeader, 800);
  }

  kickRename();

  // Observa cambios para re-aplicar SIEMPRE (no desconectamos)
  const mo = new MutationObserver(() => renameHeader());
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });

  // Cuando el drawer abre
  document.addEventListener('SLIDECART_OPENED', kickRename);

  // Cuando se actualiza (si tu implementación dispara esto)
  document.addEventListener('SLIDECART_UPDATED', kickRename);

  // Y también cuando se hace update programático
  const prevUpdate = window.SLIDECART_UPDATE;
  if (typeof prevUpdate === 'function' && !prevUpdate.__scRenameWrapped) {
    const wrapped = function () {
      const r = prevUpdate.apply(this, arguments);
      Promise.resolve(r).finally(kickRename);
      return r;
    };
    wrapped.__scRenameWrapped = true;
    window.SLIDECART_UPDATE = wrapped;
  }
});*/

/* =======================================================================
   3) CART GIFT RULES (CRAVE SAFE) - works on normal cart + slidecart
   + REFRESH /cart ONE-SHOT when script removes/changes items (flag)
   ======================================================================= */
(function () {
  // =========================
  // CONFIG
  // =========================

  const THRESHOLDS = [
    { amount: 15, handles: ['free-fast-shipping'] },
    { amount: 70, handles: ['free-electric-coffee-mixer'] },
    { amount: 95, handles: ['free-skinny-coffee-tumbler'] }
  ];

  const PHYSICAL_GIFTS = ['free-skinny-coffee-tumbler', 'free-electric-coffee-mixer'];
  const REMOVED_HANDLES = ['night-collagen-burn-3'];

  // =========================
  // CART PAGE REFRESH (CRAVE) - one-shot w/ flag
  // =========================

  const CART_REFRESH_FLAG = '__SC_CART_REFRESHED__';
  const CART_REFRESH_WINDOW_MS = 2500;

  function onCartPage() {
    return location.pathname === '/cart' || location.pathname.startsWith('/cart/');
  }

  function markCartChanged() {
    window.__SC_CART_CHANGED__ = true;
  }

  function refreshCartPageOnce() {
    if (!onCartPage()) return;

    const now = Date.now();
    const last = Number(sessionStorage.getItem(CART_REFRESH_FLAG) || 0);

    if (now - last < CART_REFRESH_WINDOW_MS) return;

    sessionStorage.setItem(CART_REFRESH_FLAG, String(now));
    location.reload();
  }

  window.addEventListener('pageshow', () => {
    setTimeout(() => sessionStorage.removeItem(CART_REFRESH_FLAG), CART_REFRESH_WINDOW_MS);
  });

  // =========================
  // CART OPS QUEUE (avoid 409/422)
  // =========================

  const SC_CART = {
    op: Promise.resolve(),
    mutatingUntil: 0
  };

  function sleep(ms) {
    return new Promise(r => setTimeout(r, ms));
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function enqueue(fn) {
    SC_CART.op = SC_CART.op.then(fn).catch(err => {
      console.warn('[SC] cart op failed (ignored)', err);
    });
    return SC_CART.op;
  }

  async function postChange(payload) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (res.ok) return res.json();
    const txt = await res.text().catch(() => '');
    return { __error: true, status: res.status, text: txt };
  }

  async function changeByKey(lineItemKey, quantity) {
    for (let attempt = 1; attempt <= 6; attempt++) {
      const cart = await getCart();
      const idx = cart.items.findIndex(i => i.key === lineItemKey);
      if (idx === -1) return null;

      const line = idx + 1;
      SC_CART.mutatingUntil = Date.now() + 1500;

      const result = await postChange({ line, quantity });
      if (result && !result.__error) return result;

      const status = result?.status;
      if (status === 409 || status === 422) {
        await sleep(180 * attempt);
        continue;
      }

      console.warn('[SC] change failed', status, result?.text || '', { line, quantity });
      return null;
    }
    return null;
  }

  function removeByKey(lineItemKey) {
    return enqueue(async () => {
      const data = await changeByKey(lineItemKey, 0);
      if (data) {
        markCartChanged();
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      }
      return data;
    });
  }

  function setQtyByKey(lineItemKey, quantity) {
    return enqueue(async () => {
      const data = await changeByKey(lineItemKey, quantity);
      if (data) {
        markCartChanged();
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      }
      return data;
    });
  }

  // =========================
  // RULE ENGINE
  // =========================

  async function enforceGiftRules(cart) {
    for (const it of cart.items) {
      if (REMOVED_HANDLES.includes(it.handle)) {
        await removeByKey(it.key);
      }
    }

    for (const handle of PHYSICAL_GIFTS) {
      const items = cart.items.filter(i => i.handle === handle);
      if (items.length > 0) {
        const [keep, ...dupes] = items;

        if (keep.quantity > 1) {
          await setQtyByKey(keep.key, 1);
        }
        for (const d of dupes) {
          await removeByKey(d.key);
        }
      }
    }
  }

  async function checkAndRemoveProducts(cart) {
    const total = cart.total_price / 100;

    for (const t of THRESHOLDS) {
      if (total < t.amount) {
        for (const h of t.handles) {
          const it = cart.items.find(i => i.handle === h);
          if (it) await removeByKey(it.key);
        }
      }
    }

    await enforceGiftRules(cart);
  }

  // =========================
  // TRIGGERS (Crave)
  // =========================

  let enforcing = false;
  async function enforceNow(reason) {
    if (enforcing) return;
    if (Date.now() < SC_CART.mutatingUntil) return;

    enforcing = true;
    try {
      console.log('[SC] enforce:', reason);
      const cart = await getCart();
      await checkAndRemoveProducts(cart);

      if (window.__SC_CART_CHANGED__) {
        window.__SC_CART_CHANGED__ = false;
        refreshCartPageOnce();
      }
    } catch (e) {
      console.warn('[SC] enforce error', e);
    } finally {
      enforcing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => enforceNow('load'));
  window.addEventListener('pageshow', () => enforceNow('pageshow'));

  const prev = window.SLIDECART_UPDATED;
  window.SLIDECART_UPDATED = async function (cart) {
    try { if (typeof prev === 'function') await prev(cart); } catch (_) {}
    await enforceNow('SLIDECART_UPDATED');
  };

  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function wrapFetch(fn) {
    if (!fn || fn.__scWrapped) return fn;
    const wrapped = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = fn.apply(this, arguments);
      if (CART_MUTATION_RE.test(url)) {
        Promise.resolve(p).then(() => enforceNow('fetch:' + url)).catch(() => {});
      }
      return p;
    };
    wrapped.__scWrapped = true;
    return wrapped;
  }

  if (typeof window.fetch === 'function') window.fetch = wrapFetch(window.fetch);

  const rehook = setInterval(() => {
    if (typeof window.fetch === 'function' && !window.fetch.__scWrapped) {
      window.fetch = wrapFetch(window.fetch);
    }
  }, 500);
  setTimeout(() => clearInterval(rehook), 8000);

  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__scCartMut = CART_MUTATION_RE.test(url || '');
    this.__scCartUrl = url || '';
    return _open.apply(this, arguments);
  };

  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__scCartMut) {
      this.addEventListener('loadend', () => enforceNow('xhr:' + this.__scCartUrl));
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('change', (e) => {
    const el = e.target;
    if ((el?.getAttribute?.('name') || '') === 'updates[]') {
      setTimeout(() => enforceNow('change:updates[]'), 700);
      setTimeout(() => enforceNow('change:updates[]:late'), 1600);
    }
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target?.closest?.('a,button');
    if (!btn) return;

    const aria = btn.getAttribute('aria-label') || '';
    const action = btn.getAttribute('data-action') || '';
    const href = btn.getAttribute('href') || '';

    const looksRemove =
      /remove|delete|trash|quitar|eliminar/i.test(aria) ||
      /remove|delete|trash|quitar|eliminar/i.test(action) ||
      /\/cart\/change|\/cart\/update|quantity=0|updates/i.test(href);

    if (looksRemove) {
      setTimeout(() => enforceNow('click:remove'), 700);
      setTimeout(() => enforceNow('click:remove:late'), 1600);
    }
  }, true);

})();
